import {
  FormGroup, TextField
} from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  useAddress
} from "components/ltr-request-document/components/Address";
import {
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function TravelInfo({
  colSpan = 6,
  bagdeStart = 19,
  formik,
  prefixFieldName = "",
  disabled = false
}) {
  const classes = useStyles();
  const masterData = useSelector(selectMasterData);
  const addressFieldOptions = useAddress({
    formik,
    ProvinceFieldName: "workpermit.ProvinceId",
    DistrictFieldName: "workpermit.DistrictId",
    SubDistrictFieldName: "workpermit.SubDistrictId",
    ZipcodeFieldName: "workpermit.Zipcode",
  });
  const accommodationConfig = get(masterData, "accommodationConfig", []);
  const vehicleConfigConfig = get(masterData, "vehicleConfig", []);
  const CountryConfig = get(masterData, "countryConfig", []);
  const VisaTypeConfig = get(masterData, "visaTypeConfig", []);
  const immPointConfig = get(masterData, "immPointConfig", []);

  const canEdit = useSelector(canEditForm);

  const index = 0;

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              {/* <InputLabel style={{ color: "#172B4D", fontWeight: "bold" }}>
                Latest travel information into Thailand
              </InputLabel> */}

              <InputLabel style={{ marginTop: 10 }}>
                Visa Information
              </InputLabel>

              <FormGroup style={{ marginTop: 10 }} row>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <FormControl variant="outlined">
                    <InputLabel>Type of visa you are holding</InputLabel>
                    <Select
                      disabled={disabled || !canEdit}
                      label="Type of visa you are holding"
                      name="workpermit.visatypeId"
                      value={formik.values.workpermit.visatypeId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {VisaTypeConfig.map((x) => (
                        <MenuItem key={x.visatypeId} value={x.visatypeId}>
                          {x.visaTypeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <TextField
                    disabled={disabled || !canEdit}
                    variant="outlined"
                    placeholder="Visa Number."
                    name="workpermit.visaNo"
                    value={formik.values.workpermit.visaNo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div className={classes.wrapField}>
                  <TextField
                    disabled={disabled || !canEdit}
                    variant="outlined"
                    placeholder="Place of visa issuance/ issued at"
                    name="workpermit.visaIssue"
                    value={formik.values.workpermit.visaIssue}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </FormGroup>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      <TableRow>
        <StyledTableCell colSpan={colSpan}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ marginTop: 10 }}>Immigration</InputLabel>

              <FormGroup style={{ marginTop: 10 }} row>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <FormControl variant="outlined">
                    <InputLabel>Port of entry</InputLabel>
                    <Select
                      disabled={disabled || !canEdit}
                      label="Port of entry"
                      name="workpermit.immPointID"
                      value={formik.values.workpermit.immPointID}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {immPointConfig.map((x) => (
                        <MenuItem key={x.immPointID} value={x.immPointID}>
                          {x.immPointNameEN}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <TextField
                    disabled={disabled || !canEdit}
                    variant="outlined"
                    label="TM 6"
                    // placeholder="TM 6"
                    name="workpermit.immNo"
                    value={formik.values.workpermit.immNo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
                <div className={classes.wrapField}>
                  <FormControl variant="outlined">
                    <InputLabel>Travel from (country)</InputLabel>
                    <Select
                      disabled={disabled || !canEdit}
                      label="Travel from (country)"
                      name="workpermit.fromCountryID"
                      value={formik.values.workpermit.fromCountryID}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {CountryConfig.map((x) => (
                        <MenuItem key={x.countryId} value={x.countryId}>
                          {x.countryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              </FormGroup>
              <FormGroup style={{ marginTop: 16 }} row>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <FormControl variant="outlined">
                    <InputLabel>Mean of transport</InputLabel>
                    <Select
                      disabled={disabled || !canEdit}
                      label="Mean of transport"
                      name="workpermit.vehicleID"
                      value={formik.values.workpermit.vehicleID}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      {vehicleConfigConfig.map((x) => (
                        <MenuItem key={x.vehicleID} value={x.vehicleID}>
                          {x.vehicleNameEN}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className={classes.wrapField} style={{ marginRight: 16 }}>
                  <DatePicker
                    disabled={disabled || !canEdit}
                    inputVariant="outlined"
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="The latest arrival date in Thailand"
                    views={["year", "month", "date"]}
                    name="workpermit.thaiLastDate"
                    value={formik.values.workpermit.thaiLastDate || null}
                    onChange={(date) => {
                      formik.setFieldValue(
                        `workpermit.thaiLastDate`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`workpermit.thaiLastDate`, formik)}
                    helperText={getErrorMessage(
                      `workpermit.thaiLastDate`,
                      formik
                    )}
                  />
                </div>

                <div className={classes.wrapField}>
                  <DatePicker
                    disabled={disabled || !canEdit}
                    inputVariant="outlined"
                    disablePast
                    disableFuture={false}
                    openTo="year"
                    format="DD-MM-YYYY"
                    label="Permitted to stay in Thailand"
                    views={["year", "month", "date"]}
                    name="workpermit.stampEXP"
                    // value={formik.values.workpermit.stampEXP || null}
                    value={
                      get(formik.values, `workpermit.stampEXP`, null) || null
                    }
                    onChange={(date) => {
                      formik.setFieldValue(
                        `workpermit.stampEXP`,
                        date.format("YYYY-MM-DD")
                      );
                    }}
                    error={isError(`workpermit.stampEXP`, formik)}
                    helperText={getErrorMessage(`workpermit.stampEXP`, formik)}
                  />
                </div>
              </FormGroup>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
